import { OnboardingModule } from "components/common/OnboardingModule";
import { OnboardingTask } from "components/common/OnboardingTypes";
import { useUpdateProductPrompts } from "services/nux";
import { useEffect, useState } from "react";
import { PROD_ONBOARDING_AVAILABILITY_FORM_UUID } from "components/documents/constants";
import { Collapse } from "@mui/material";
import { Member } from "protogen/common_pb";
import { useNavigate } from "react-router-dom";
import { Family } from "protogen/advisors_service_pb";

interface MemberOnboardingModuleProps {
  member: Member;
  family: Family;
}

export default ({ member, family }: MemberOnboardingModuleProps) => {
  const navigate = useNavigate();
  const { request: updateProductPrompts } = useUpdateProductPrompts();
  const [productPrompts, setProductPrompts] = useState<any>(null);

  useEffect(() => {
    if (member) {
      try {
        const productPrompts = JSON.parse(member?.productPrompts || "{}");
        setProductPrompts(productPrompts);
      } catch (e) {}
    }
  }, [member]);

  const handleDismissTask = async (taskKey: string) => {
    await updateProductPrompts({ key: taskKey, value: "dismissed" });
    setProductPrompts((prev: any) => ({
      ...prev,
      [taskKey]: "dismissed",
    }));
  };

  const handleAddFirstTask = () => {
    navigate("/tasks/add", { state: { family: family } });
  };

  const tasks: OnboardingTask[] = [
    {
      label: "Add your first task",
      completed: productPrompts?.hasCreatedFirstTask,
      url: "/tasks/add?from=onboarding",
      dismissible: true,
      dismissed: productPrompts?.hasCreatedFirstTask === "dismissed",
      onDismiss: () => handleDismissTask("hasCreatedFirstTask"),
      onClick: handleAddFirstTask,
    },
    {
      label: "Set up your calendar integration",
      completed: productPrompts?.hasCalendarIntegration,
      url: "/settings/calendars?from=onboarding",
      dismissible: true,
      dismissed: productPrompts?.hasCalendarIntegration === "dismissed",
      onDismiss: () => handleDismissTask("hasCalendarIntegration"),
    },
    {
      label: "Fill out your onboarding availability",
      completed: productPrompts?.advisorOnboardingAvailabilityFormCompleted,
      url: `/forms/complete/${PROD_ONBOARDING_AVAILABILITY_FORM_UUID}`,
      dismissible: true,
      dismissed:
        productPrompts?.advisorOnboardingAvailabilityFormCompleted ===
        "dismissed",
      onDismiss: () =>
        handleDismissTask("advisorOnboardingAvailabilityFormCompleted"),
    },
    {
      label: "Add partner as an account holder",
      completed: productPrompts?.hasAddedPartner,
      url: `/settings?addMember=true`,
      dismissible: true,
      dismissed: productPrompts?.hasAddedPartner === "dismissed",
      onDismiss: () => handleDismissTask("hasAddedPartner"),
    },
  ];

  if (
    !productPrompts ||
    Object.keys(productPrompts).length === 0 ||
    tasks.every((t) => t.dismissed || t.completed)
  ) {
    return null;
  }
  return (
    <Collapse in={!!productPrompts} timeout={800}>
      <OnboardingModule
        tasks={tasks}
        title="Welcome to Faye!"
        subtitle="Complete these steps to get the most out of working with your Advisor."
        dismissKey="member-onboarding-dismissed"
        dismissDays={7}
        collapseSx={{ marginBottom: "0px" }}
        showDismiss={false}
      />
    </Collapse>
  );
};
